import { useState } from "react";
import { Icon } from "./Icon";
import { Sheet } from "./Sheet";

const REG_NR = "6695";
const KONTONUMMER = "1006890276";

function CopyField({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false);

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard access can be denied by the browser — the field is still
      // visible to copy by hand, so there's nothing else to fall back to.
    }
  };

  return (
    <div className="flex items-center justify-between gap-3 py-3.5 px-4 rounded-lg bg-paper2">
      <div className="min-w-0">
        <div className="font-mono text-[10px] tracking-wide text-ink3 uppercase">{label}</div>
        <div className="font-display font-extrabold text-lg tracking-tight tabular-nums mt-0.5">
          {value}
        </div>
      </div>
      <button
        onClick={onCopy}
        className="flex items-center gap-1.5 py-2 px-3 rounded-lg border border-line font-mono text-[10.5px] font-semibold uppercase tracking-wide text-ink2 flex-shrink-0"
      >
        <Icon name={copied ? "check" : "copy"} size={12} />
        {copied ? "Kopieret" : "Kopiér"}
      </button>
    </div>
  );
}

export function BankInfoSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Sheet open={open} onClose={onClose} title="Logens bankkonto">
      <div className="text-[13px] leading-relaxed text-ink2 mb-4">
        Bøder betales til logens bankkonto inden afslutningen af næste loge-arrangement.
      </div>
      <div className="flex flex-col gap-2">
        <CopyField label="Reg. nr." value={REG_NR} />
        <CopyField label="Kontonummer" value={KONTONUMMER} />
      </div>
      <button
        onClick={onClose}
        className="w-full mt-5 py-3.5 px-4 rounded-lg bg-ink text-paper font-display text-sm font-bold tracking-wide uppercase"
      >
        Luk
      </button>
    </Sheet>
  );
}
